import { Target, ComponentType } from 'data-types-config';
import type { PhoneDestinationProps } from './PhoneDestination.types';

export const phoneDestinationDefaults: Partial<PhoneDestinationProps> = {
  target: Target.Blank,
  componentType: ComponentType.Telephone,
  isDisabled: false,
  isVisible: true,
  text: '',
};
